import axios from 'axios'

import { getDefaultRange } from '../utils/dateHelper'

export const simulateDelay = (data) => {
  return new Promise(resolve => {
    setTimeout(() => resolve(data), Math.random() * 1500)
  })
}

export const $ = axios.create({
  baseURL: 'http://api-p1.overfli.com/ipm_service/api/v2/',
  headers: {
    'content-type': 'application/json',
    'api-key': 'test-8552a3dc-5394-4040-9a65-43739d543746',
    'x-auth': localStorage.getItem('token') ? localStorage.getItem('token') : '',

  },
})

export const mFileUploader = axios.create({
  baseURL: 'http://api-p1.overfli.com/ipm_service/api/v2/',
  headers: {
    'content-type': 'multipart/form-data',
    'api-key': 'test-8552a3dc-5394-4040-9a65-43739d543746',
    'x-auth': localStorage.getItem('token') ? localStorage.getItem('token') : ''
  },
})


export const authenticate = ({ email, password }) => {
  return $.post('manager/login', { email, password }).catch(err => {
    console.error("Http Error : ",err)
    return err;
  });
}

export const fetchJobs = (startDate, endDate) => {
  console.log("********** api.fetchJobs");
  if (!startDate || !endDate) {
    const daterange = getDefaultRange()
    startDate = daterange.startDate
    endDate = daterange.endDate
  }
  endDate = endDate.clone().add(1, 'day')
  return $.get(`manager/get_jobs_more_details/${localStorage.getItem('userUUID')}/${startDate.format('YYYY-MM-DD')}/${endDate.format('YYYY-MM-DD')}`).catch(err => {
    console.error("Http Error : ",err)
    return err;
  });
}

export const fetchDealers = () => {
  return $.get(`manager/get_all_dealers/${localStorage.getItem('userUUID')}`).catch(err => {
    console.error("Http Error : ",err)
    return err;
  });
}

export const fetchDealersBySearchTerm = (searchTerm) => {
  return $.post(`manager/search_dealer/${localStorage.getItem('userUUID')}`, { searchTerm }).catch(err => {
    console.error("Http Error : ",err)
    return err;
  });
}

export const fetchEmployees = () => {
  return $.get(`manager/get_all_users/${localStorage.getItem('userUUID')}`).catch(err => {
    console.error("Http Error : ",err)
    return err;
  });
}

export const fetchEmployeesBySearchTerm = (searchTerm) => {
  return $.post(`manager/search_user/${localStorage.getItem('userUUID')}`, { searchTerm }).catch(err => {
    console.error("Http Error : ",err)
    return err;
  });
}

export const updateEmployee = (employee, id) => {
  return $.post(`manager/update_employee/${localStorage.getItem('userUUID')}/${id}`, employee).catch(err => {
    console.error("Http Error : ",err)
    return err;
  });
}

export const updateJobStatus = (id, status) => {
  return $.post(`manager/update_job_status/${localStorage.getItem('userUUID')}`, {
    'UUID': id,
    'status': status,
  }).catch(err => {
    console.error("Http Error : ",err)
    return err;
  });
}

export const createNewJob = (newJob) => {
  return $.post(`manager/new_counting_job/${localStorage.getItem('userUUID')}`, newJob).catch(err => {
    console.error("Http Error : ",err)
    return err;
  });
}

export const updateJob = (job, id) => {
  return $.post(`manager/update_counting_job/${localStorage.getItem('userUUID')}/${id}`, job).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const fetchJobById = (id) => {
  console.log("******** api.fetchJobById");
  return $.get(`manager/get_counting_job_more_details/${localStorage.getItem('userUUID')}/${id}`).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const updateDealer = (dealer, id) => {
  return $.post(`manager/update_dealer/${localStorage.getItem('userUUID')}/${id}`, dealer).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const processLocalSnapshotFile = (dealerUUID, formData) => {
  return $.post(`manager/dealer_inventory/process_save_local_inventory_file/${localStorage.getItem('userUUID')}/${dealerUUID}`, formData).catch(err => {
    console.error("processLocalSnapshotFile Http Error : ",err)
    return err;
  })
}

export const startScan = (id) => {
  return $.post(`manager/set_counting_job_scan_started/${localStorage.getItem('userUUID')}/${id}`).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const completeScan = (id) => {
  return $.post(`manager/set_counting_job_scan_completed/${localStorage.getItem('userUUID')}/${id}`).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const abortJob = (id) => {
  return $.post(`manager/set_counting_job_aborted/${localStorage.getItem('userUUID')}/${id}`).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const createNewDealer = (newDealer) => {
  return $.post(`manager/new_cdk_dealer/${localStorage.getItem('userUUID')}`, newDealer).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const deleteDealer = (dealer, reason) => {
  return $.post(`manager/update_dealer_status/${localStorage.getItem('userUUID')}`, {
    UUID: dealer.UUID,
    status: 'deleted',
  }).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const getJobsByDealer = (dealer) => {
  return $.get(`manager/get_jobs_by_dealer/${localStorage.getItem('userUUID')}/${dealer.UUID}`).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const getJobsByEmployee = (user) => {
  return $.get(`manager/get_jobs_by_user/${localStorage.getItem('userUUID')}/${user.UUID}`).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const getUsersForAGivenJob = (id) => {
  return $.get(`manager/get_users_by_job/${localStorage.getItem('userUUID')}/${id}`).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const getCountingResultsForAGivenJob = (id) => {
  return $.get(`manager/get_counting_job_results/${localStorage.getItem('userUUID')}/${id}`).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const getCountingSummaryForAGivenJob = (id) => {
  return $.get(`manager/get_counting_summary_by_job/${localStorage.getItem('userUUID')}/${id}`).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const getCountingSummaryByDealer = (id) => {
  return $.get(`manager/get_counting_summary_by_dealer/${localStorage.getItem('userUUID')}/${id}`).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const addCountingResult = (part, id) => {
  return $.post(`manager/add_counting_job_result/${localStorage.getItem('userUUID')}/${id}`, part).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const updateCountingResult = (part, id) => {
  return $.post(`manager/update_existing_counting_job_result/${localStorage.getItem('userUUID')}/${id}/${part.id}`, {
    bin: part.bin,
    partNumber: part.partNumber,
    count: part.count,
  }).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const searchCountingResultByTerm = (jobId, searchTerm) => {
  return $.post(`manager/search_counting_job_results/${localStorage.getItem('userUUID')}/${jobId}`, { searchTerm }).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const searchCountingResultByUser = (jobId, userId) => {
  return $.get(`manager/get_counting_job_results_by_input_user/${localStorage.getItem('userUUID')}/${jobId}/${userId}`).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const deleteCountingResult = (part, id) => {
  return $.post(`manager/delete_counting_job_result/${localStorage.getItem('userUUID')}/${id}`, part).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const assignUserForJob = (jobId, userId) => {
  return $.post(`manager/add_users_to_job/${localStorage.getItem('userUUID')}/${jobId}`, [ userId ]).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const removeUserFromJob = (jobId, userId) => {
  return $.post(`manager/remove_users_from_job/${localStorage.getItem('userUUID')}/${jobId}`, [ userId ]).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const createNewEmployee = (newEmployee) => {
  return $.post(`manager/new_user/${localStorage.getItem('userUUID')}`, newEmployee).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const deleteEmployee = (employee, reason) => {
  return $.post(`manager/update_employee_status/${localStorage.getItem('userUUID')}`, {
    UUID: employee.UUID,
    status: 'deleted',
  }).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const confirmEmployeeToJob = (employee, job) => {
  return $.post(`manager/confirm_user_for_job/${localStorage.getItem('userUUID')}/${job.UUID}/${employee.UUID}`).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const sendUserInviteForJob = (employee, job) => {
  return $.post(`manager/invite_user_for_job/${localStorage.getItem('userUUID')}/${job.UUID}/${employee.UUID}`).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const sendAllUsersInviteForJob = (employees, job) => {
  return $.post(`manager/invite_users_for_job/${localStorage.getItem('userUUID')}/${job.UUID}`, employees).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const changePassword = (UUID, newPassword) => {
  return $.post(`manager/reset_user_password/${localStorage.getItem('userUUID')}`, { UUID, newPassword }).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const changeOwnPassword = (oldPassword, newPassword) => {
  return $.post(`manager/reset_self_password/${localStorage.getItem('userUUID')}`, { oldPassword, newPassword }).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const updateUserEmail = (UUID, email) => {
  return $.post(`manager/update_user_email/${localStorage.getItem('userUUID')}`, { UUID, email }).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const updateUserStatus = (UUID, status) => {
  return $.post(`manager/update_user_status/${localStorage.getItem('userUUID')}`, { UUID, status }).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const updateUserRole = (UUID, role) => {
  return $.post(`manager/update_user_role/${localStorage.getItem('userUUID')}`, { UUID, role }).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const addNewUser = (user) => {
  return $.post(`manager/new_user/${localStorage.getItem('userUUID')}`, user).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const updateUserData = (id, user) => {
  return $.post(`manager/update_user_info/${localStorage.getItem('userUUID')}/${id}`, user).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const XpopulateTestVarianceData = (id, countingMode = 'bin_centric') => {
  return $.get(`special/populate_test_variance_data/e83c62b4cfae/${id}/${countingMode}`).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}



export const getVarianceCheckingPendingPartnumBin = (jobId) => {
  return $.get(`manager/variance_checking/get_not_assigned_partnum_data/${localStorage.getItem('userUUID')}/${jobId}`).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const getVarianceCheckingAllPartnumBin = (jobId) => {
  return $.get(
    `manager/variance_checking/get_user_assign_partnum_count/${localStorage.getItem('userUUID')}/${jobId}`
  ).catch(err => {
    console.error("Http Error : ", err);
    return err;
  });
};

export const getVarianceCheckingUserAssignments = (jobId) => {
  return $.get(`manager/variance_checking/get_user_assign_partnum_count/${localStorage.getItem('userUUID')}/${jobId}`).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const assignPartnumsBinCentric = (varianceListId, varianceAssignBody) => {
  return $.post(`manager/variance_checking/assign_users_bin_centric/${localStorage.getItem('userUUID')}/${varianceListId}`, varianceAssignBody).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const assignPartnumsPartCentric = (varianceListId, varianceAssignBody) => {
  return $.post(`manager/variance_checking/assign_users_partnum_centric/${localStorage.getItem('userUUID')}/${varianceListId}`, varianceAssignBody).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const getSummaryInfoForJob = (jobId) => {
  return $.get(`manager/variance_checking/get_summary_info_for_job/${localStorage.getItem('userUUID')}/${jobId}`).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const getPartnumData = (varianceCheckingId) => {
  return $.get(`manager/variance_checking/get_partnum_data_for_checking_id/${localStorage.getItem('userUUID')}/${varianceCheckingId}`).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}


export const updateVarianceCheckingStatus = (varianceCheckingId, status) => {
  return $.post(`manager/variance_checking/update_checking_status/${localStorage.getItem('userUUID')}/${varianceCheckingId}`, { status })
}

export const updatePrimaryBin = (varianceCheckingId, partNumber, bin) => {
  return $.post(`manager/variance_checking/update_primary_bin/${localStorage.getItem('userUUID')}/${varianceCheckingId}`, {
    partNumber,
    bin,
  }).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const addPartnumSecondaryBin = (varianceCheckingId, partNumber, bin, firstCount) => {
  return $.post(`manager/variance_checking/add_partnum_secondary_bin/${localStorage.getItem('userUUID')}/${varianceCheckingId}`, {
    partNumber,
    bin,
    firstCount,
  }).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const addPartnumPrimaryBin = (varianceCheckingId, partNumber, bin, firstCount, countOnFile) => {
  return $.post(`manager/variance_checking/add_partnum_primary_bin/${localStorage.getItem('userUUID')}/${varianceCheckingId}`, {
    partNumber,
    bin,
    firstCount,
    countOnFile,
  }).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const deletePartnum = (varianceCheckingId, partNumber) => {
  return $.post(`manager/variance_checking/delete_partnum/${localStorage.getItem('userUUID')}/${varianceCheckingId}`, {
    partNumber,
  }).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const deleteSecondaryBin = (varianceCheckingId, partNumber, bin) => {
  return $.post(`manager/variance_checking/delete_secondary_bin/${localStorage.getItem('userUUID')}/${varianceCheckingId}`, {
    partNumber,
    bin,
  }).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const updateSecondCount = (varianceCheckingId, partNumber, bin, count) => {
  return $.post(`manager/variance_checking/update_second_count/${localStorage.getItem('userUUID')}/${varianceCheckingId}`, {
    partNumber,
    bin,
    count,
  }).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}
export const varianceAccept = (varianceCheckingId, accepted) => {
  return $.post(`manager/variance_checking/accept_partnum/${localStorage.getItem('userUUID')}/${varianceCheckingId}`, accepted,
  ).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}
export const setVarianceActive = (varianceCheckingId, active) => {
  return $.post(`manager/variance_checking/set_partnum_active/${localStorage.getItem('userUUID')}/${varianceCheckingId}`, active,
  ).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}
export const createVarianceChecking = (countingJobUUID, countingMode, typeString, orderId) => {
  return $.post(`manager/variance_checking/create_new_variance_checking/${localStorage.getItem('userUUID')}/${countingJobUUID}/${countingMode}/${typeString}`, { orderId }).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const createNextStandardVarianceChecking = (jobId, data) => {
  return $.post(`manager/variance_checking/create_next_standard_variance_checking/${jobId}/${localStorage.getItem('userUUID')}/${data.num_of_users}`, data);
}

export const getDataFromDms = (job_uuid) => {

  return $.get(`manager/get_dms_data_push_status/${localStorage.getItem('userUUID')}/${job_uuid}`).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}
export const pushDataToDms = (job_uuid) => {
  return $.post(`manager/start_dms_data_push/${localStorage.getItem('userUUID')}/${job_uuid}`).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })

}
export const getPendingTasks = (job_uuid) => {
  return $.get(`manager/get_counting_job_pending_tasks/${localStorage.getItem('userUUID')}/${job_uuid}`).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}
export const getBinForTable = (varianceCheckingId, job_uuid) => {
  return $.get(`manager/variance_checking/specific/get_all_partnum_data/${localStorage.getItem('userUUID')}/${job_uuid}/${varianceCheckingId}`).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const getBinSummaryForCountingJob = (job_uuid) => {
  return $.get(`manager/get_bin_summary_by_job/${localStorage.getItem('userUUID')}/${job_uuid}`).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const getAvailableReports = () => {
  return  $.get(`manager/report/get_available_reports/${localStorage.getItem('userUUID')}`).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const pushToReports = (report_name, params) => {
  return $.post(`manager/report/query_report/${localStorage.getItem('userUUID')}/${report_name}`, {...params} ).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const newJobTask = (jobId, taskData) => {
  return $.post(`manager/new_job_task/${localStorage.getItem('userUUID')}/${jobId}`, taskData).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const getJobTaskStatus = (taskUuid) => {
  return $.get(`manager/get_job_task_status/${localStorage.getItem('userUUID')}/${taskUuid}`).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const getJobLocalScripts = (job_uuid, scriptType) => {
  return $.get(`manager/get_counting_job_local_script/${scriptType}/${localStorage.getItem('userUUID')}/${job_uuid}`, {
    responseType: "blob"
  }).
  catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const updateJobSetupData = (job_uuid) => {
  return $.post(`manager/update_counting_job_setup_data/${localStorage.getItem('userUUID')}/${job_uuid}`).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const getLatestLocalInventoryFile = (dealer_uuid) => {
  return $.get(`manager/dealer_inventory/get_latest_local_inventory_file/${localStorage.getItem('userUUID')}/${dealer_uuid}`, {
    responseType: "blob"
  }).
  catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export const createStandardVarianceChecking = (job_uuid, variance_request) => {
  return $.post(`manager/variance_checking/create_standard_variance_checking/${job_uuid}/${localStorage.getItem('userUUID')}/${variance_request.num_of_users}`).catch(err => {
    console.error("Http Error : ",err)
    return err;
  });
}

export const clearCountingTrackingByBins = (job_uuid, bins) => {
  return $.post(`manager/clear_counting_tracking_by_bins/${localStorage.getItem('userUUID')}/${job_uuid}`, { bins }).catch(err => {
    console.error("Http Error : ",err)
    return err;
  })
}

export default {
  simulateDelay,
  fetchJobs,
  fetchDealers,
  fetchDealersBySearchTerm,
  fetchEmployees,
  authenticate,
  updateJobStatus,
  createNewJob,
  updateJob,
  fetchJobById,
  updateDealer,
  createNewDealer,
  deleteDealer,
  startScan,
  completeScan,
  abortJob,
  getUsersForAGivenJob,
  getCountingResultsForAGivenJob,
  getCountingSummaryForAGivenJob,
  addCountingResult,
  updateCountingResult,
  deleteCountingResult,
  assignUserForJob,
  removeUserFromJob,
  fetchEmployeesBySearchTerm,
  updateEmployee,
  createNewEmployee,
  deleteEmployee,
  confirmEmployeeToJob,
  sendUserInviteForJob,
  sendAllUsersInviteForJob,
  getJobsByDealer,
  getJobsByEmployee,
  getCountingSummaryByDealer,
  searchCountingResultByTerm,
  searchCountingResultByUser,
  changePassword,
  changeOwnPassword,
  updateUserEmail,
  updateUserStatus,
  updateUserRole,
  updateUserData,
  addNewUser,
  XpopulateTestVarianceData,
  getVarianceCheckingPendingPartnumBin,
  getVarianceCheckingAllPartnumBin,
  getVarianceCheckingUserAssignments,
  assignPartnumsBinCentric,
  assignPartnumsPartCentric,
  getSummaryInfoForJob,
  getPartnumData,
  updateVarianceCheckingStatus,
  addPartnumSecondaryBin,
  deleteSecondaryBin,
  addPartnumPrimaryBin,
  deletePartnum,
  clearCountingTrackingByBins,
  updateSecondCount,
  varianceAccept,
  setVarianceActive,
  createVarianceChecking,
  getPendingTasks,
  pushDataToDms,
  getDataFromDms,
  getBinForTable,
  getBinSummaryForCountingJob,
  getAvailableReports,
  pushToReports,
  newJobTask,
  getJobTaskStatus,
  processLocalSnapshotFile,
  getJobLocalScripts,
  getLatestLocalInventoryFile,
  updateJobSetupData,
  createStandardVarianceChecking,
  createNextStandardVarianceChecking,
}
